import React, { useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { tokens } from '../theme';
import CustomButton from './CustomButton';

import dayjs, {  } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers';

const DatePickerButton = ({ onDateSelect }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const today = dayjs();
    const minSelectableDate = today.subtract(1, 'year');
    const maxSelectableDate = today.add(1, 'year');
    const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);

    const handleButtonClick = () => {
        setIsDatePickerVisible(!isDatePickerVisible);
    };

    const handleDateChange = (date) => {
        setSelectedDate(date);
        onDateSelect(dayjs(selectedDate).format('YYYY-MM-DD')); // Callback function to return the selected date
        setIsDatePickerVisible(false); // Hide the date picker after selection
    };

    return (
        <Box
            style={{
                display: 'flex',
                justifyContent: 'flex-end',
                position: 'relative',
                width: '100%',
            }}
        >
            <CustomButton
                btnBG={colors.grey[900]}
                btnColor={colors.grey[100]}
                btnStartIcon={
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.55896 0.837209C8.55896 0.374831 8.18413 0 7.72175 0C7.25937 0 6.88454 0.374831 6.88454 0.837209V1.70862C5.17076 1.85154 3.81179 2.44564 2.85398 3.47713C1.75526 4.66037 1.30469 6.29056 1.30469 8.09332V17.5817C1.30469 19.3844 1.75526 21.0146 2.85398 22.1979C3.96313 23.3924 5.61023 24.0003 7.72329 24.0003H16.6535C18.7666 24.0003 20.4137 23.3924 21.5228 22.1979C22.6216 21.0146 23.0721 19.3844 23.0721 17.5817V8.09332C23.0721 6.29056 22.6216 4.66037 21.5228 3.47713C20.5647 2.4453 19.2052 1.85115 17.4906 1.70847V0.837209C17.4906 0.374831 17.1158 0 16.6534 0C16.191 0 15.8162 0.374831 15.8162 0.837209V1.67471H8.55896V0.837209ZM6.88454 3.38979V4.18605C6.88454 4.64842 7.25937 5.02326 7.72175 5.02326C8.18413 5.02326 8.55896 4.64842 8.55896 4.18605V3.34913H15.8162V4.18605C15.8162 4.64842 16.191 5.02326 16.6534 5.02326C17.1158 5.02326 17.4906 4.64842 17.4906 4.18605V3.38962C18.8134 3.524 19.7075 3.98291 20.2958 4.61649C20.9832 5.35668 21.367 6.45725 21.396 7.91406H2.98087C3.00979 6.45725 3.39366 5.35668 4.08098 4.61649C4.66906 3.98317 5.56262 3.52439 6.88454 3.38979ZM2.97911 9.58848V17.5817C2.97911 19.1278 3.36575 20.2883 4.08098 21.0585C4.78578 21.8175 5.92938 22.3259 7.72329 22.3259H16.6535C18.4474 22.3259 19.591 21.8175 20.2958 21.0585C21.0111 20.2883 21.3977 19.1278 21.3977 17.5817V9.58848H2.97911ZM15.1946 13.8973C15.1946 13.2808 15.6944 12.781 16.3109 12.781H16.3209C16.9374 12.781 17.4372 13.2808 17.4372 13.8973C17.4372 14.5138 16.9374 15.0136 16.3209 15.0136H16.3109C15.6944 15.0136 15.1946 14.5138 15.1946 13.8973ZM16.3109 16.1297C15.6944 16.1297 15.1946 16.6294 15.1946 17.2459C15.1946 17.8624 15.6944 18.3622 16.3109 18.3622H16.3209C16.9374 18.3622 17.4372 17.8624 17.4372 17.2459C17.4372 16.6294 16.9374 16.1297 16.3209 16.1297H16.3109ZM11.0657 13.8973C11.0657 13.2808 11.5655 12.781 12.182 12.781H12.192C12.8085 12.781 13.3083 13.2808 13.3083 13.8973C13.3083 14.5138 12.8085 15.0136 12.192 15.0136H12.182C11.5655 15.0136 11.0657 14.5138 11.0657 13.8973ZM12.182 16.1297C11.5655 16.1297 11.0657 16.6294 11.0657 17.2459C11.0657 17.8624 11.5655 18.3622 12.182 18.3622H12.192C12.8085 18.3622 13.3083 17.8624 13.3083 17.2459C13.3083 16.6294 12.8085 16.1297 12.192 16.1297H12.182ZM6.93482 13.8973C6.93482 13.2808 7.4346 12.781 8.0511 12.781H8.06113C8.67763 12.781 9.1774 13.2808 9.1774 13.8973C9.1774 14.5138 8.67763 15.0136 8.06113 15.0136H8.0511C7.4346 15.0136 6.93482 14.5138 6.93482 13.8973ZM8.0511 16.1297C7.4346 16.1297 6.93482 16.6294 6.93482 17.2459C6.93482 17.8624 7.4346 18.3622 8.0511 18.3622H8.06113C8.67763 18.3622 9.1774 17.8624 9.1774 17.2459C9.1774 16.6294 8.67763 16.1297 8.06113 16.1297H8.0511Z" fill="#292D32"/>
                    </svg>
                }
                btnEndIcon={
                    <img src="../../assets/common/Arrow-down.svg" height={8} />
                }
                btnTxt={'DATE'}
                onClick={handleButtonClick}
                style={{
                    width: '150px',
                    alignSelf: 'flex-end',
                }}
            ></CustomButton>

            {isDatePickerVisible && (
                <Box
                    mt={1}
                    style={{
                        position: 'absolute',
                        top: '100%',
                        right: 0,
                        zIndex: 1000,
                    }}
                    sx={{
                        border: `1px solid ${colors.grey[400]}`, 
                        borderRadius: '3px', 
                    }}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        {/* <DatePicker
                    label="Choose Date"
                    value={selectedDate}
                    onChange={(newValue) => setSelectedDate(newValue)}
                    /> */}

                        <StaticDatePicker
                            //defaultValue={setTodaysDate}
                            label="Choose Date"
                            value={selectedDate}
                            onChange={(newValue) => setSelectedDate(newValue)}
                            onAccept={() => handleDateChange(selectedDate)}
                            onCancel={() => setIsDatePickerVisible(false)}
                            minDate={minSelectableDate}
                            maxDate={maxSelectableDate}
                            orientation="landscape"
                        />
                    </LocalizationProvider>
                </Box>
            )}
        </Box>
    );
};

export default DatePickerButton;
